<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import messages from '@/locales/about/messages.ts'

const { t, locale } = useI18n({
    useScope: 'global',
    messages: messages
});
</script>
<template>
    <div id="category_header">
        <img src="/img/about/background.jpg" alt="KaseFilters.fr" />
        <h1>{{ $t('aboutkase.title') }}</h1>
    </div>
    <div class="content">
        <p>{{ $t('aboutkase.description') }}</p>
        <v-row>
            <v-col cols="12" md="6">
                <v-card elevation="5">
                    <v-card-title class="text-center">
                        <h2>{{$t('aboutkase.creation_date')}}</h2>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <p class="text-h3 text-red-lighten-1">2011</p>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card elevation="5">
                    <v-card-title class="text-center">
                        <h2>{{$t('aboutkase.patents')}}</h2>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <p class="text-h3 text-red-lighten-1">30<sup>+</sup></p>
                    </v-card-text>
                </v-card>
                
            </v-col>
        </v-row>
        <v-timeline align="start">
            <v-timeline-item v-for="(year, index) in messages.fr.aboutkase.history" :key="index">
                <template #opposite>
                    <b>{{$t('aboutkase.history.'+index+'.year')}}</b>
                </template>
                <div>
                    <ul>
                        <li v-for="(item, idx) in year.events" :key="idx">{{ $t('aboutkase.history.'+index+'.events.'+idx) }}</li>
                    </ul>
                </div>
            </v-timeline-item>
        </v-timeline>
    </div>
</template>
<style lang="scss" scoped>
#category_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 190px;
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 30px;
        font-weight: 700;
        line-height: 36.57px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    h2{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
}

    .row{
        flex-wrap: wrap;
    }
    h1, h2{
        margin-bottom: 10px;
    }
    div{
        margin-bottom: 10px;
    }
    p{
        margin-bottom: 10px;
        margin-top: 10px;
    }
    ol, ul{
        margin-bottom: 10px;
        margin-top: 10px;
        margin-left: 20px;
    }
    @media only screen and (min-width : $responsive-point) {
        .row{
            flex-wrap: nowrap;
        }
    }
</style>
<route lang="yaml">
name: aboutkase
props: true
meta:
    title: A propos de KaseFilters
    layout: default
    description: Découvrez l'histoire de KaseFilters
    middleware: guest
</route>